/**
 * Connoisseur: the deep end of the loot lever.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const CONNOISSEUR = {
  id: 'connoisseur',
  branch: 'scavenging',
  tier: 3,
  title: 'Connoisseur',
  blurb: 'You can date a Vensell tin by the font. This is not the skill you trained for.',
  maxRanks: 2,
  minLevel: 17,
  requires: ['binPicker'],
  statGrants: {},
  effects: [{ field: 'lootQuality', perRank: 0.08, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
